<mat-dialog-content>
  <div class="row mb-2">
    <div>
      <div class="col-4">
        <label>Motivo da Ressalva</label>
        <textarea
          class="form-control"
          style="width: 700px"
          data-cy="reservation"
          rows="5"
          maxlength="1000"
          name="reservation"
          [(ngModel)]="reservation"
        >
        </textarea>
        <span class="text-right">0/1000 caracteres</span><br />
      </div>
    </div>
  </div>

  <button
    style="width: 150px"
    *ngIf="reservation.length > 10"
    (click)="saveReservation()"
  >
    <span>Salvar</span>
  </button>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Fechar</button>
  </mat-dialog-actions>
</mat-dialog-content>
